import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '@app/auth/auth.service';
import { PlexEnvironment } from '@app/env';
import { ButtonDirective } from '@progress/kendo-angular-buttons';
import { SVGIcon } from '@progress/kendo-angular-icons';
import { MenuModule } from '@progress/kendo-angular-menu';
import { fullscreenIcon, reorderIcon, userIcon } from "@progress/kendo-svg-icons";
import { ThemeObject } from 'environments/env-name';
import screenfull from 'screenfull';
import { EnvThemeService } from '../../services/env-theme.service';
import { AssetTeamSelectionComponent } from '../assetteam-selection/assetteam-selection.component';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AssetTeamSelectionComponent,
    ButtonDirective,
    MenuModule,
    NgStyle,
  ]
})
export class ToolbarComponent implements OnInit {
  private envThemeService = inject(EnvThemeService);
  private authService = inject(AuthService);
  public environment = inject(PlexEnvironment);

  public showDelawareBasin: boolean;
  public hideAllButPATAndDELBasins: boolean;

  public userIsLoggedIn: boolean = false;

  public refreshLoggedIn() {
    const loggedin = this.authService.isUserLoggedIn();
  }
  public userImage: SVGIcon = userIcon;
  public fullScreenImage: SVGIcon = fullscreenIcon;
  public reorderImage: SVGIcon = reorderIcon;
  public get userName() {
    return this.authService?.activeAccount() ?? '';
  }

  readonly toggled = input<any>(undefined);
  public envName: string;
  public bgColor1: {};
  public bgColor2: {};
  public envTheme: ThemeObject;
  public isSPM: boolean = false;
  public spmAppUrl: string = this.environment.spmAppUrl;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);
  constructor() {
    this.isSPM = this.environment.isSpm;
    this.showDelawareBasin = this.environment.showDelawareBasin;
    this.hideAllButPATAndDELBasins = this.environment.hideAllButPATAndDELBasins;
  }

  ngOnInit() {
    this.envTheme = this.envThemeService.getEnvStyle();
    this.envName = this.envTheme.envName;
    if (this.envTheme.themeColors.length > 0) {
      this.bgColor1 = this.envTheme.themeColors[0];
    } else {
      this.bgColor1 = null;
      this.envName = '';
    }

    this.userIsLoggedIn = this.authService.isUserLoggedIn();

    this.authService.$permissions.subscribe(o => {
      this.userIsLoggedIn = this.authService.isUserLoggedIn();
    });
  }

  public toggleSidebar() {
    document.querySelector('body').classList.toggle('sidebar-hidden');
  }

  public onSelect({ item }): void {
    if (item.text === 'Login') {
      this.login();
    } else if (item.text === 'Logout') {
      this.logout();
    }
  }

  public login() {
    this.authService.login();
  }

  public async logout() {
    await this.authService.logout();
  }

  public toggleFullScreen() {
    if (screenfull.isEnabled) {
      screenfull.toggle();
    }
  }
}